@if (spinnerService.loading) {
  <app-spinner />
} 

<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
<!-- @if (slideMenuService.showed) {
  <app-slide-menu />
} -->
<router-outlet></router-outlet>
